import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import store from '../store'

Vue.use(VueRouter)

const routes = [
  {path: '/', name: 'Home', component: () => import('../views/Home.vue')},
  {path: '/Configurar', name: 'Configurar', component: () => import('../views/Configurar.vue')},
  {path: '/VerRutaActual', name: 'VerRutaActual', component: () => import('../views/VerRutaActual.vue')},
  {path: '/Logout', name: 'Logout', component: () => import('../views/Logout.vue')},
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) =>  {  

  //console.log("De: "+from.path+" - A: "+to.path)

  if (from.path==="/" && to.path==="/home") {
    //No hago nada, porque es redundante
  } else {
    if (to.path === '/Configurar' || store.state.choferes.choferActual.loggeado) {
      next()
    } else {
      next('/Configurar')
    }
  }
})

export default router
